"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var integralMall_1 = require("../../model/integralMall");
var service_1 = require("../../../library/base/service");
var Init = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Init, _super);
    function Init() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '微信端签到活动初始化';
        _this.code = '301145';
        _this.desc = '微信端签到活动初始化';
        _this.requestParams = new integralMall_1.InitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Init;
}(service_1.BaseService));
exports.Init = Init;
//# sourceMappingURL=init.js.map